import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { 
  Package, // For Strength
  Box, // For Square Bottom
  Leaf, // For Eco-Friendly
  PenTool, // For Customization
} from 'lucide-react';

const ProductCategory2 = () => {
  const features = [
    {
      icon: Package,
      title: "Superior Strength",
      description: "Made from high-grade kraft paper, providing excellent durability for heavy groceries and retail items.",
      bgColor: "#8B4513" // Brown for strength
    },
    {
      icon: Box,
      title: "Flat Bottom",
      description: "Sturdy square bottom design ensures stability and keeps items upright during transport.",
      bgColor: "#CD853F" // Light brown for structure
    },
    {
      icon: Leaf,
      title: "Eco-Friendly",
      description: "Natural, unbleached materials that are 100% recyclable and biodegradable for sustainable packaging.",
      bgColor: "#556B2F" // Dark olive green for eco
    },
    {
      icon: PenTool,
      title: "Brand Ready",
      description: "Natural kraft surface ideal for custom printing, stamping, or embossing your brand identity.",
      bgColor: "#8B7355" // Tan brown for customization
    }
  ];

  return (
    <div className="container py-5">
      <div className="text-center mb-5">
        <h2 className="main-heading display-5 fw-bold mb-3">Discover Features</h2>
        <p className="product-each-desc text-muted mx-auto" style={{ maxWidth: '700px' }}>
          Premium kraft paper bags combining robust construction with environmental responsibility, featuring a convenient square bottom and superior strength for all your packaging needs.
        </p>
      </div>

      <div className="row g-4">
        {features.map((feature, index) => {
          const IconComponent = feature.icon;
          return (
            <div key={index} className="col-12 col-sm-6 col-lg-3">
              <div className="card h-100 border-0 shadow-sm feature-card">
                <div className="text-center mt-4">
                  <div 
                    className="icon-container d-inline-flex align-items-center justify-content-center rounded-3 mb-4"
                    style={{ background: feature.bgColor }}
                  >
                    <IconComponent size={40} className="icon-img" />
                  </div>
                </div>
                
                <div className="card-body text-center">
                  <h3 className="card-title h5 mb-3">{feature.title}</h3>
                  <p className="card-text text-muted mb-4">{feature.description}</p>
                </div>
              </div>
            </div>
          );
        })}
      </div>

      <style>
        {`
          .feature-card {
            transition: all 0.3s ease;
            position: relative;
            overflow: hidden;
          }

          .feature-card::after {
            content: '';
            position: absolute;
            bottom: 0;
            left: 0;
            width: 0;
            height: 3px;
            background-color: #dc3545;
            transition: width 0.3s ease;
          }

          .feature-card:hover {
            transform: translateY(-10px);
          }

          .feature-card:hover::after {
            width: 100%;
          }

          .icon-container {
            width: 80px;
            height: 80px;
            transition: all 0.3s ease;
          }

          .icon-img {
            color: white;
          }

          .feature-card:hover .icon-container {
            transform: scale(1.1);
          }
        `}
      </style>
    </div>
  );
};

export default ProductCategory2;